import React from "react";

import { motion } from "framer-motion";

import { useTheme } from "../../contexts/ThemeContext";

export default function HamburgerMenu({ isOpen }) {
  const { theme } = useTheme();

  const upBottomVariants = {
    close: {
      pathLength: 0.38,
      pathOffset: -0.68,
      stroke: theme === "dark" ? "#ffffff" : "#555",
    },
    open: { pathLength: 0.66, pathOffset: -2, stroke: "#de1b25" },
  };

  const middleVariant = {
    close: { pathLength: 1, opacity: 1 },
    open: { pathLength: 0, opacity: 0 },
  };

  return (
    <motion.svg
      initial={false}
      animate={isOpen ? "open" : "close"}
      width="38"
      height="37"
      viewBox="0 0 38 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <motion.path
        d="m 5.5,9.5 c 0,0 16.2767,16 21.5,21 5.2233,5 9.5,6.5 9.5,2 0,-4.5 -2.5,-5.6006 -4.2767,-5.6006 H 16.5 1"
        strokeWidth="2"
        strokeLinecap="round"
        variants={upBottomVariants}
        transition={{ duration: 0.5 }}
      />
      <motion.path
        d="M 6,27 C 6,27 21.4172,12.2999 27,6.14997 32.5828,-1.43051e-6 36.5,-0.350033 36.5,4.14996 36.5,8.64995 34,9.7506 32.2233,9.7506 H 26.017834 16.5 1"
        strokeWidth="2"
        strokeLinecap="round"
        variants={upBottomVariants}
        transition={{ duration: 0.6 }}
      />
      <motion.path
        d="M 31,18 H 1"
        stroke={theme === "dark" ? "#ffffff" : "#555"}
        strokeWidth="2"
        strokeLinecap="round"
        variants={middleVariant}
        transition={{ duration: 0.4 }}
      />
    </motion.svg>
  );
}
